import Topo from "../../../../../Componentes/TopCategorias"
import { useStyles } from "./style"
import CheckoutButton from "../../../../../Componentes/CheckoutButton"
import { useHistory } from "react-router-dom"
import { useEffect, useState } from "react"
import tariffsRequest from "../../../../../Services/api/tariffs"
import { CircularProgress } from "@material-ui/core"

function FeesAndTariffsMercadoPago() {
  const classes = useStyles()
  const history = useHistory()
  const [tariffs, setTariffs] = useState(null)
  const [loading, setLoading] = useState(true)

  const [error, setError] = useState(false)

  useEffect(() => {
    async function loadTariffs() {
      try {
        const response = await tariffsRequest.get()
        if (response.data.error) {
          setError(true)
          return
        }
        setTariffs(response.data.tarifas)
      } catch (error) {
        console.error("Erro ao carregar tarifas:", error)
        setError(true)
      } finally {
        setLoading(false)
      }
    }

    loadTariffs()
  }, [])

  if (loading) {
    return (
      <div className="page-container">
        <div className="page-align">
          <Topo name="Taxas e tarifas" />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "calc(100vh - 100px)",
              marginTop: "20px"
            }}
          >
            <CircularProgress color="secondary" size="40px" />
          </div>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="page-container">
        <div className="page-align">
          <Topo name="Taxas e tarifas" />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "calc(100vh - 100px)",
              marginTop: "20px",
              textAlign: "center",
              gap: "20px"
            }}
          >
            <h3 style={{ color: "#f44336" }}>Ops! Algo deu errado</h3>
            <p>Não foi possível carregar as informações de tarifas no momento.</p>
            <CheckoutButton
              onClick={() => window.location.reload()}
              maxWidth="300px"
              borderRadius={10}
              fontSize={16}
              fontWeight={500}
              height="50px"
            >
              Tentar novamente
            </CheckoutButton>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="page-container">
      <div className="page-align">
        <div>
          <Topo name="Taxas e tarifas" />
        </div>

        <div className={`${classes.feesContainer} infinite-scroll`}>
          <h3 className={classes.title}>Minhas taxas e tarifas:</h3>

          <div className={classes.paymentSection}>
            <h4 className={classes.paymentType}>Cartões de Crédito</h4>
            <div className={classes.feeRow}>
              Tarifa de processamento:{" "}
              <span>
                {tariffs?.cartao?.processamento || "R$ 0,00"} por transação
              </span>
            </div>
            <div className={classes.feeRow}>
              Taxa do Checkout:{" "}
              <span>
                {tariffs?.cartao?.transacional || "0%"} do valor total do pedido
              </span>
            </div>
          </div>

          <div className={classes.paymentSection}>
            <h4 className={classes.paymentType}>PIX</h4>
            <div className={classes.feeRow}>
              Tarifa de processamento:{" "}
              <span>{tariffs?.pix?.processamento || "R$ 0,00"} por transação</span>
            </div>
            <div className={classes.feeRow}>
              Taxa do Checkout:{" "}
              <span>
                {tariffs?.pix?.transacional || "0%"} do valor total do pedido
              </span>
            </div>
          </div>

          <div className={classes.paymentSection}>
            <h4 className={classes.paymentType}>Boleto bancário</h4>
            <div className={classes.unavailableText}>
              (não disponível no momento)
            </div>
          </div>
        </div>

        <div className="footer-column">
          <CheckoutButton
            onClick={() => {
              history.push("/suporte-tecnico")
            }}
            maxWidth="100%"
            borderRadius={10}
            fontSize={16}
            fontWeight={500}
            height="50px"
            marginBottom="15px"
          >
            Deseja tarifas melhores?
          </CheckoutButton>
        </div>
      </div>
    </div>
  )
}

export default FeesAndTariffsMercadoPago
